<!--
 * @Description: 示例页面
 * @Author: sunxiaodong
 * @Date: 2020-07-27 10:50:35
 * @LastEditors: sunxiaodong
 * @LastEditTime: 2020-07-27 11:24:48
-->
<template>
  <div>测试</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
